export const CalculatorKeys = {
	all: ["calculator"] as const,
	access: () => [...CalculatorKeys.all, "access"] as const,
	legacyAccess: () => [...CalculatorKeys.all, "legacyAccess"] as const,
	mortgageRates: () => [...CalculatorKeys.all, "mortgageRates"] as const,
	refinancingRates: () => [...CalculatorKeys.all, "refinancingRates"] as const,
	consumerLoanSettings: () =>
		[...CalculatorKeys.all, "consumerLoanSettings"] as const,
};
